export default function _transHours(value) {
  if ((value + '').length < 13) value *= 1000;
  let d = new Date(value);
  return d.getHours();
}